import { getTransactionId } from '../../common/data';
import { store } from '../../redux';
import {
  DataStorageRequest,
  DataStorageUpdateResponse,
  setDataStorageNew,
} from '../../redux/features/dataStorage.redux';
import { callFes, callFesWithLoading } from '../index';

// Read journey data from the Data Storage Service
export const getDataStorage = (id: string): Promise<any> => {
  return callFes.get(`datastorage/${id}`);
};

/**
 * @deprecated - To be removed.
 */
export const updateDataStorage = (data: any): Promise<any> => {
  const id = getTransactionId();
  return callFes.patch(`datastorage/${id}/update`, data);
};

export const updateDataStorageNew = (transactionId: string, request: DataStorageRequest) => {
  return callFesWithLoading
    .patch<DataStorageUpdateResponse>(`datastorage/${transactionId}/update`, request)
    .then((data) => {
      store.dispatch(setDataStorageNew(data.custom));
      return data;
    });
};

// Creates a new transaction and stores it in Data Storage Service
export const putDataStorage = async (data: any): Promise<string> => {
  const res = await callFes.put(`datastorage/create`, data);
  return res.transaction.id;
};
